import { render, staticRenderFns } from "./moduleDialog.vue?vue&type=template&id=cb6fa35c&scoped=true"
import script from "./moduleDialog.vue?vue&type=script&lang=js"
export * from "./moduleDialog.vue?vue&type=script&lang=js"
import style0 from "./moduleDialog.vue?vue&type=style&index=0&id=cb6fa35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6fa35c",
  null
  
)

export default component.exports